import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { colors } from './styles'

interface PageHeaderProps {
  readonly title: string
  readonly count?: number
  readonly subtitle?: string
  readonly actions?: ReactNode
  readonly onRefresh?: () => void
  readonly backTo?: string
  readonly backLabel?: string
}

export function PageHeader({ title, count, subtitle, actions, onRefresh, backTo, backLabel }: PageHeaderProps) {
  const navigate = useNavigate()

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
      <div>
        {backTo && (
          <button
            type="button"
            onClick={() => navigate(backTo)}
            style={{
              background: 'none',
              border: 'none',
              color: colors.accent,
              cursor: 'pointer',
              fontSize: '0.875rem',
              padding: '0 0 0.25rem 0',
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
            }}
          >
            <span style={{ fontSize: '1rem' }}>{'\u2190'}</span>
            {backLabel ?? 'Back'}
          </button>
        )}
        <h1
          style={{
            margin: 0,
            fontSize: '1.375rem',
            color: colors.textHeading,
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
          }}
        >
          {title}
          {count !== undefined && <span style={{ color: colors.accent, fontSize: '1rem' }}>{count}</span>}
        </h1>
        {subtitle && <p style={{ margin: '0.25rem 0 0', color: colors.textMuted, fontSize: '0.875rem' }}>{subtitle}</p>}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
        {onRefresh && (
          <button
            onClick={onRefresh}
            style={{
              background: 'none',
              border: 'none',
              color: colors.accent,
              cursor: 'pointer',
              fontSize: '0.875rem',
              textDecoration: 'underline',
            }}
          >
            Refresh
          </button>
        )}
        {actions && <div style={{ display: 'flex', gap: '0.5rem' }}>{actions}</div>}
      </div>
    </div>
  )
}
